export default __webpack_public_path__ + "static/media/logo.fe4a05db.svg";